import React, { FC, memo } from "../../../lib/teact/teact";
import Spinner from "../../ui/Spinner";
import './loading.scss'
type OwerProp = {
    text?: string;
    size?: 'small' | 'tiny' | 'large';
}

const LotLoading: FC<OwerProp> = ({
    text,
    size,
}) => {
    let style = "width:15px;height:25px;"
    if (size == 'small') {
        style = "width:10px;height:20px;"
    }
    if (size == 'tiny') {
        style = "width:8px;height:16px;"
    }
    return (
        //style="display: flex;align-items: center; justify-content: center;height: 100vh;gap:10px;"
        <div className="loading-main">
            <div className="loading">
                <div>{text ? text : "Đang tải dữ liệu..."}</div>
                <div style={style}>
                    <Spinner   ></Spinner>
                </div>

            </div>
        </div>
    )
}
export default memo(LotLoading)